import { Err, Ok } from "@pacote/result"
import CodiceFiscale from "codice-fiscale-js"

export function getTaxCode(
  ...data: ConstructorParameters<typeof CodiceFiscale>
) {
  try {
    // the constructor throws an error if the data is invalid
    const taxCode = new CodiceFiscale(...data)
    return Ok(taxCode)
  } catch (error) {
    if (error instanceof Error) {
      return Err(error.message)
    } else {
      return Err("Unknown error while creating fiscal code")
    }
  }
}
